import { z } from "zod";

/**
 * User OAuth auth — OAuth app credentials provided by the connecting organization.
 * The org brings their own OAuth client; tokens stored in ToolCredentials.
 */
export const CustomManifestUserOAuthSchema = z.object({
  type: z.literal("user_oauth"),
  grant_type: z.enum(["code", "pkce", "client_credentials", "refresh_token"]).optional(),
  authorization_type: z.enum(["basic", "bearer", "custom"]).optional(),
  custom_header_name: z.string().optional(),
  custom_header_prefix: z.string().optional()
});

export type CustomManifestUserOAuth = z.infer<typeof CustomManifestUserOAuthSchema>;
